import React from "react";
import DataTable from "react-data-table-component";
import { Triangle } from "react-loader-spinner";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const CustomTable = ({ loading, columns, data, ...props }) => {
  return (
    <div>
      <DataTable
        responsive
        striped
        pagination
        persistTableHead
        highlightOnHover
        pointerOnHover
        progressPending={loading}
        customStyles={customStyles}
        progressComponent={
          <div className="my-3">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <h5 className="mt-1">Loading...</h5>
          </div>
        }
        {...props}
        columns={columns}
        data={data}
      />
    </div>
  );
};

export default CustomTable;
